import React from 'react';
import { useTranslation } from 'react-i18next';

function EditEventModal({ 
  isOpen, 
  onClose, 
  onSave, 
  editForm, 
  setEditForm, 
  handleImageChange,
  loading 
}) {
  const { t } = useTranslation();
  
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(44, 62, 80, 0.8)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        padding: '20px',
        overflowY: 'auto'
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '16px',
          padding: '30px',
          maxWidth: '600px',
          width: '100%',
          border: '4px solid #2C3E50',
          boxShadow: '8px 8px 0px #2C3E50',
          position: 'relative',
          maxHeight: '90vh',
          overflowY: 'auto'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* 닫기 버튼 */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '15px',
            right: '15px',
            background: 'transparent',
            border: 'none',
            fontSize: '24px',
            cursor: 'pointer',
            color: '#7F8C8D',
            fontWeight: '700'
          }}
        >
          ✕
        </button>

        {/* 제목 */}
        <h2 style={{
          fontSize: '24px',
          fontWeight: '700',
          color: '#2C3E50',
          margin: '0 0 24px 0'
        }}>
          ✏️ {t('event.editEvent')}
        </h2>

        {/* 이벤트 이름 */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{
            display: 'block',
            marginBottom: '8px',
            fontSize: '14px',
            fontWeight: '700',
            color: '#2C3E50'
          }}>
            {t('home.eventName')}
          </label>
          <input
            type="text"
            value={editForm.name}
            onChange={(e) => setEditForm(prev => ({ ...prev, name: e.target.value }))}
            style={{
              width: '100%',
              padding: '12px',
              fontSize: '15px',
              border: '2px solid #2C3E50',
              borderRadius: '8px',
              boxSizing: 'border-box',
              fontFamily: 'inherit'
            }}
          />
        </div>

        {/* 상품 이미지 */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{
            display: 'block',
            marginBottom: '8px',
            fontSize: '14px',
            fontWeight: '700',
            color: '#2C3E50'
          }}>
            {t('home.productImage')}
          </label>
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            style={{
              width: '100%',
              padding: '12px',
              fontSize: '14px',
              border: '2px solid #2C3E50',
              borderRadius: '8px',
              boxSizing: 'border-box',
              cursor: 'pointer',
              fontFamily: 'inherit'
            }}
          />
          <p style={{
        fontSize: '12px',
        color: '#7F8C8D',
        marginTop: '6px',
        marginBottom: '0'
       }}>
  💡 {t('home.imageGuide')}
       </p>

       
          {editForm.imagePreview && (
            <div style={{
              marginTop: '12px',
              border: '2px solid #2C3E50',
              borderRadius: '8px',
              padding: '10px',
              textAlign: 'center'
            }}>
              <img
                src={editForm.imagePreview}
                alt="Preview"
                style={{
                  maxWidth: '100%',
                  maxHeight: '200px',
                  borderRadius: '4px'
                }}
              />
            </div>
          )}
        </div>

        {/* 상품 설명 */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{
            display: 'block',
            marginBottom: '8px',
            fontSize: '14px',
            fontWeight: '700',
            color: '#2C3E50'
          }}>
            {t('home.productDescription')}
          </label>
          <textarea
            value={editForm.description}
            onChange={(e) => setEditForm(prev => ({ ...prev, description: e.target.value }))}
            style={{
              width: '100%',
              padding: '12px',
              fontSize: '15px',
              border: '2px solid #2C3E50',
              borderRadius: '8px',
              boxSizing: 'border-box',
              minHeight: '100px',
              resize: 'vertical',
              fontFamily: 'inherit'
            }}
          />
        </div>

        {/* 배송 방법 */}
        <div style={{ marginBottom: '30px' }}>
          <label style={{
            display: 'block',
            marginBottom: '8px',
            fontSize: '14px',
            fontWeight: '700',
            color: '#2C3E50'
          }}>
            {t('home.deliveryMethod')}
          </label>
          <textarea
            value={editForm.deliveryMethod}
            onChange={(e) => setEditForm(prev => ({ ...prev, deliveryMethod: e.target.value }))}
            style={{
              width: '100%',
              padding: '12px',
              fontSize: '15px',
              border: '2px solid #2C3E50',
              borderRadius: '8px',
              boxSizing: 'border-box',
              minHeight: '80px',
              resize: 'vertical',
              fontFamily: 'inherit'
            }}
          />
        </div>

        {/* 버튼들 */}
        <div style={{
          display: 'flex',
          gap: '12px'
        }}>
          <button
            onClick={onClose}
            disabled={loading}
            style={{
              flex: 1,
              padding: '14px',
              backgroundColor: '#FFFFFF',
              border: '2px solid #2C3E50',
              borderRadius: '8px',
              cursor: loading ? 'not-allowed' : 'pointer',
              fontSize: '16px',
              fontWeight: '700',
              color: '#2C3E50',
              fontFamily: 'inherit'
            }}
          >
            {t('logout.cancel')}
          </button>

          <button
            onClick={onSave}
            disabled={loading}
            style={{
              flex: 1,
              padding: '14px',
              backgroundColor: loading ? '#95A5A6' : '#6BCB77',
              border: '2px solid #2C3E50',
              borderRadius: '8px',
              cursor: loading ? 'not-allowed' : 'pointer',
              fontSize: '16px',
              fontWeight: '700',
              color: '#FFFFFF',
              fontFamily: 'inherit'
            }}
          >
            {loading ? t('event.saving') : t('event.saveChanges')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditEventModal;